import { Lock } from 'lucide-react'

interface Props {
  title?: string
  description?: string
}

/** Shared "no tools" state for Home and the No access page (DESIGN §4.2). */
export default function NoAccessState({
  title = 'No tools assigned to your role',
  description = 'Ask an Administrator for access.',
}: Props) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-16 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-gray-100">
        <Lock size={24} className="text-gray-400" />
      </div>
      <div>
        <p className="text-sm font-semibold text-gray-600">{title}</p>
        <p className="mt-1 max-w-xs text-xs text-gray-400">{description}</p>
      </div>
    </div>
  )
}
